// icon CDN: https://icons8.com/icons/set/flags--style-color
// the commented out countries are not supported by the icon library
const countryFlagMap = {
  Afghanistan: 'https://img.icons8.com/color/48/afghanistan-flag-circle.png',
  'Åland Islands': 'https://img.icons8.com/color/48/aland-islands-circular.png',
  Andorra: 'https://img.icons8.com/color/48/andora-circular.png',
  'Antigua & Barbuda': 'https://img.icons8.com/color/48/antigua-and-barbuda-circular.png',
  'Bosnia & Herzegovina': 'https://img.icons8.com/color/48/bosnia-and-herzegovina-circular.png',
  Brunei: 'https://img.icons8.com/color/48/brunei-darussalam-circular.png',
  'Caribbean Netherlands': 'https://img.icons8.com/color/48/caribbean-netherlands-circular.png',
  'Cocos (Keeling) Islands': 'https://img.icons8.com/color/48/cocos-keeling-islands-circular.png',
  // 'Congo - Brazzaville': 'https://img.icons8.com/color/48/congo-brazzaville-circular.png',
  'Congo - Kinshasa': 'https://img.icons8.com/color/48/congo-kinshasa-circular.png',
  'Costa Rica': 'https://img.icons8.com/color/48/casta-rica-circular.png',
  'Côte d’Ivoire': 'https://img.icons8.com/color/48/ivory-coast-circular.png',
  Curaçao: 'https://img.icons8.com/color/48/curaao-circular.png',
  Czechia: 'https://img.icons8.com/color/48/czech-republic-circular.png',
  Eswatini: 'https://img.icons8.com/color/48/swaziland-circular.png',
  'Falkland Islands (Islas Malvinas)': 'https://img.icons8.com/color/48/falkland-islands-circular.png',
  'French Guiana': 'https://img.icons8.com/color/48/france-circular.png',
  Guadeloupe: 'https://img.icons8.com/color/48/france-circular.png',
  Haiti: 'https://img.icons8.com/color/48/the-republic-of-haiti-circular.png',
  'Hong Kong': 'https://img.icons8.com/color/48/hongkong-circular.png',
  // Kosovo: 'https://img.icons8.com/color/48/.png',
  Martinique: 'https://img.icons8.com/color/48/france-circular.png',
  // Mayotte: 'https://img.icons8.com/color/48/.png',
  'Myanmar (Burma)': 'https://img.icons8.com/color/48/myanmar-circular.png',
  'New Caledonia': 'https://img.icons8.com/color/48/france-circular.png',
  'North Macedonia': 'https://img.icons8.com/color/48/macedonia-circular.png',
  // Palau: 'https://img.icons8.com/color/48/.png',
  Réunion: 'https://img.icons8.com/color/48/france-circular.png',
  Russia: 'https://img.icons8.com/color/48/russian-federation-circular.png',
  'São Tomé & Príncipe': 'https://img.icons8.com/color/48/sao-tome-and-principe-circular.png',
  Serbia: 'https://img.icons8.com/color/48/sernia-circular.png',
  // 'Sint Maarten': 'https://img.icons8.com/color/48/.png',
  // 'St. Barthélemy': 'https://img.icons8.com/color/48/.png',
  // 'St. Helena': 'https://img.icons8.com/color/48/.png',
  'St. Kitts & Nevis': 'saint-kitts-and-nevis-circularhttps://img.icons8.com/color/48/.png',
  'St. Lucia': 'https://img.icons8.com/color/48/saint-lucia-circular.png',
  // 'St. Martin': 'https://img.icons8.com/color/48/.png',
  'St. Pierre & Miquelon': 'https://img.icons8.com/color/48/france-circular.png',
  'St. Vincent & Grenadines': 'https://img.icons8.com/color/48/saint-vincent-and-the-grenadines-circular.png',
  // 'Svalbard & Jan Mayen': 'https://img.icons8.com/color/48/.png',
  Taiwan: 'https://img.icons8.com/color/48/taiwan-flag-circle.png',
  'Trinidad & Tobago': 'https://img.icons8.com/color/48/trinidad-and-tobago-circular.png',
  'Tristan da Cunha': 'https://img.icons8.com/color/48/great-britain-circular.png',
  Türkiye: 'https://img.icons8.com/color/48/turkey-circular.png',
  'Turks & Caicos Islands': 'https://img.icons8.com/color/48/turks-and-caicos-islands-circular.png',
  // 'U.S. Virgin Islands': 'https://img.icons8.com/color/48/.png',
  'United States': 'https://img.icons8.com/color/48/usa-circular.png',
  'Wallis & Futuna': 'https://img.icons8.com/color/48/france-circular.png',
  'United Kingdom': 'https://img.icons8.com/color/48/great-britain-circular.png',
} as const;

export const getFlagUrl = (countryName: string) => {
  if (countryName in countryFlagMap) {
    return countryFlagMap[countryName as keyof typeof countryFlagMap];
  }

  return `https://img.icons8.com/color/48/${countryName.split(' ').join('-').toLowerCase()}-circular.png`;
};
